import { render } from "./buisnessIndivid.vue?vue&type=template&id=6a5f9452&scoped=true"
import script from "./buisnessIndivid.vue?vue&type=script&lang=js"
export * from "./buisnessIndivid.vue?vue&type=script&lang=js"

import "./buisnessIndivid.vue?vue&type=style&index=0&id=6a5f9452&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5f9452"]])

export default __exports__